
/**
 * 콘텐츠 유형
 */
export type GetApiCoursesCourseIdLecturesLectureId200ContentType = typeof GetApiCoursesCourseIdLecturesLectureId200ContentType[keyof typeof GetApiCoursesCourseIdLecturesLectureId200ContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCoursesCourseIdLecturesLectureId200ContentType = {
  VIDEO: 'VIDEO',
  ARTICLE: 'ARTICLE',
  QUIZ: 'QUIZ',
  ASSIGNMENT: 'ASSIGNMENT',
} as const;
